const APIS_URL = 'https://donate.oicloud.org'
const CHANGE_SUBSCRIPTION_API = `${APIS_URL}/api/changesubscriptionsum/check`
const DONATE_API = `${APIS_URL}/api/donate`
const UNSUBSCRIBE_API = `${APIS_URL}/api/unsubscribe/check`
const CHECK_DONATION_STATE_API = `${APIS_URL}/api/donations/check-state`

function isJson (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

function request (method, url, data, cb) {
  let request = new window.XMLHttpRequest()
  request.open(method, url, true)
  request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
  request.onload = function () {
    if (request.status >= 200 && request.status < 400) {
      let res = request.responseText
      if (isJson(res)) res = JSON.parse(res)
      cb(null, res)
    } else {
      return cb(new Error('Request failed. Returned status: ' + request.status))
    }
  }
  request.onerror = function (error) {
    return cb(error)
  }

  if (data) {
    request.send(JSON.stringify(data))
  } else {
    request.send()
  }
}

export default {
  donate (donation, cb) {
    request('POST', DONATE_API, donation, cb)
  },
  unsubscribe (email, reason, cb) {
    request('POST', UNSUBSCRIBE_API + '/' + email, { reason }, cb)
  },
  changeSubscription (email, from, to, cb) {
    request('POST', CHANGE_SUBSCRIPTION_API + '/' + email, { old_sum: from, new_sum: to }, cb)
  },
  checkDonationState (donationId, cb) {
    request('GET', CHECK_DONATION_STATE_API + '/' + donationId, {}, cb)
  }
}
